<div class="position-relative w-100 overflow-hidden">
  <div>
    <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>

    <div class="position-relative w-100 overflow-hidden">
      <!-- Placeholder Hero Image -->
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/YM7UHzcylG01T3wbiqoa37im3JPxAL9CcMhxHY9k.jpg"
        alt="Contact Us Hero" class="img-fluid w-100 d-block" />
      <div
        class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-center text-start px-3 px-md-5">
        <h1 class="headingBL title mb-3 text-white">
          Contact Us
        </h1>
        <div class="d-flex align-items-center gap-3 justify-content-start">
          <a href="tel:+91-9667166988" class="text-white text-decoration-none d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="white">
              <path
                d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
          </a>
          <span class="text-white" style="font-size: 30px; line-height: 1;">|</span>
          <a href="mailto:info@virsaindia.in" class="text-white text-decoration-none d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512" fill="none"
              stroke="white" stroke-width="40">
              <rect x="50" y="100" width="412" height="312" rx="20" ry="20" />
              <polyline points="50,130 256,280 462,130" fill="none" />
              <line x1="50" y1="412" x2="200" y2="280" />
              <line x1="462" y1="412" x2="312" y2="280" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<section class="formSection">
  <div class="block">
    <div class="formCard">
      <div class="contact-header"></div>
      <div class="form-content">
        <h2 class="headingBL text-center">
          {{ formOf.title1 }} <span>{{ formOf.title2 }}</span>
        </h2>
        <div class="title-underline"></div>
        <p class="subText text-center" *ngIf="formOf.sub !== ''">
          Please fill form or email us at
          <a href="mailto:partnership@virsaindia.in">partnership@virsaindia.in</a>
        </p>

        <form [formGroup]="formGroup" (ngSubmit)="submit()">
          <!-- Name Field -->
          <div class="form-group">
            <input type="text" placeholder="Name" formControlName="myName" class="formField" />
            <div class="alertV" *ngIf="
              formGroup.get('myName')?.hasError('required') &&
              formGroup.get('myName')?.touched
            ">
              Name is required
            </div>
            <div class="alertV" *ngIf="
              formGroup.get('myName')?.hasError('minlength') &&
              formGroup.get('myName')?.touched
            ">
              Name must be at least 3 characters
            </div>
          </div>

          <!-- Mobile Number Field -->
          <div class="mobileFieldContainer mb-3">
            <input type="text" value="+91" class="formField countryCode" readonly />
            <div class="flex-grow-1">
              <input type="tel" placeholder="Mobile Number" maxlength="10" formControlName="mobileNumber"
                class="formField" />
              <div class="alertV" *ngIf="
                formGroup.get('mobileNumber')?.hasError('required') &&
                formGroup.get('mobileNumber')?.touched
              ">
                Mobile Number is required
              </div>
              <div class="alertV" *ngIf="
                formGroup.get('mobileNumber')?.hasError('pattern') &&
                formGroup.get('mobileNumber')?.touched
              ">
                Enter a valid 10-digit mobile number
              </div>
            </div>
          </div>

          <!-- Email Field -->
          <div class="form-group">
            <input type="email" placeholder="Email Address" formControlName="email" class="formField" />
            <div class="alertV" *ngIf="
              formGroup.get('email')?.hasError('required') &&
              formGroup.get('email')?.touched
            ">
              Email is required
            </div>
            <div class="alertV" *ngIf="
              formGroup.get('email')?.hasError('email') &&
              formGroup.get('email')?.touched
            ">
              Invalid email format
            </div>
          </div>

          <!-- File Upload (Conditional) -->
          <div class="form-group" *ngIf="formOf.file !== ''">
            <input type="file" class="fileField" formControlName="myResume" />
          </div>

          <!-- Product Selection (Conditional) -->
          <div class="form-group" *ngIf="formOf.sub == ''">
            <select name="selectedGenre" id="genreSelectionField" formControlName="selectedGenre">
              <option value="" disabled selected>Select Product</option>
              <option [value]="item" *ngFor="let item of productList">
                {{ item }}
              </option>
            </select>
            <div class="alertV" *ngIf="
              formGroup.get('selectedGenre')?.hasError('required') &&
              formGroup.get('selectedGenre')?.touched
            ">
              Please select a product
            </div>
          </div>

          <!-- Comments Field -->
          <div class="form-group">
            <textarea class="comment" formControlName="comment" rows="3" placeholder="Comments (Optional)"></textarea>
          </div>

          <!-- Submit Button -->
          <div class="submitBtnContainer">
            <button type="submit" class="btnGlobal--primary" [disabled]="formGroup.invalid">
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>